export const formChoices = {
  createdDate: 'Date Added',
  description:
    `The National Background Investigation Services (NBIS) Electronic Application (eApp) system contains the investigative
    Standard Forms (SF) that federal applicants and employees use to provide the necessary information to process their
    personnel background investigations.`,
  formName: 'Form Name',
  formVersion: 'Form Version',
  instructions:
    `Review the form(s) assigned to you below.
     Select the form to view and complete it as soon as possible to avoid delays in processing.`,
  orgName: 'Organization',
  pocEmail: 'Point of Contact Email',
  pocName: 'Point of Contact',
  select: 'Select',
  status: 'Status',
  title1: 'Welcome to NBIS eApp',
  title2: 'My Forms',
};
